import * as Yup from "yup";

export const initialValues = {
  host: null,
  port: null,
  userName: null
};

const companyConfigMailSchema = Yup.object().shape({
});

export default companyConfigMailSchema;
